import React from "react";
import DocsWidget from "@/components/widgets/DocsWidget";
import NotesWidget from "@/components/widgets/NotesWidget";
import SelectScreeningStatus from "@/components/applications/SelectScreeningStatus";
import CheckListCard from "@/components/tasks/CheckListCard";

const IdentificationTab = () => {
  return (
    <div>
      <div className="p-3">
        <div className="row">
          <div className="col">
            <ReviewIDCard />
            <CertifyIDCard />
          </div>
          <div className="col col-4">
            <SelectScreeningStatus className="mb-3" />
            <hr />
            <NotesWidget />
            <DocsWidget />
          </div>
        </div>
      </div>
    </div>
  );
};

const ReviewIDCard = () => (
  <CheckListCard
    title="Identification Review"
    caption="Review that applicant has succesfully completed authorization form."
  >
    <button className="btn btn-primary">View identification</button>
  </CheckListCard>
);

const CertifyIDCard = () => (
  <CheckListCard title="Was the applicant's identification able to be verified?">
    <button className="btn btn-success me-2">Yes</button>
    <button className="btn btn-danger">No</button>
  </CheckListCard>
);

IdentificationTab.propTypes = {};

export default IdentificationTab;
